var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 21h-7c-1.2 0-2.2-.9-2.3-2l-1-12.6h13.6l-1 12.5c-.1 1.2-1 2.1-2.3 2.1v0zM20 6.4H4M9.2 3h5.6c.6 0 1.1.5 1.1 1.1v2.3H8.1V4c-.1-.5.5-1 .9-1zM14 10.9v5.6m-4-5.6v5.6"
  }))));
}
export default SvgTrash;